import axios from 'axios';
import jwt_decode from 'jwt-decode';
const isExpired = (token) => token ? new Date() > token.expiresAt : true;
const parseToken = (token) => {
    if (!token) {
        return null;
    }
    try {
        const decodedPayload = jwt_decode(token);
        return {
            raw: token,
            expiresAt: new Date(decodedPayload.exp * 1000),
            ...decodedPayload
        };
    }
    catch (e) {
        console.log(e);
        return null;
    }
};
const userAgentInterceptor = (userAgent) => (req) => {
    req.headers.set('User-Agent', userAgent);
    return req;
};
const authorizationInterceptor = (tokenRef) => (req) => {
    // Check if Authorization header is already set
    if (req.headers.has('Authorization')) {
        return req;
    }
    const token = tokenRef?.current?.token;
    // Set Authorization header with the valid token
    if (token && !isExpired(token)) {
        req.headers.set('Authorization', `Bearer ${token.raw}`);
    }
    if (token && isExpired(token)) {
        console.log(`SOP token expired token=${token.raw}`);
    }
    return req;
};
export const makeSOPClientProtocol = ({ baseUrl, userAgent, withXSRFToken = true }) => {
    const tokenRef = { current: null };
    const httpProvider = axios.create({ withXSRFToken, withCredentials: true });
    const setToken = (token) => {
        const parsedToken = parseToken(token);
        if (parsedToken) {
            tokenRef.current = {
                token: parsedToken
            };
        }
        else {
            tokenRef.current = null;
        }
    };
    httpProvider.interceptors.request.use(authorizationInterceptor(tokenRef));
    if (userAgent)
        httpProvider.interceptors.request.use(userAgentInterceptor(userAgent));
    return {
        httpProvider,
        makeUrl: (url) => `${baseUrl}${url}`,
        deleteToken: () => {
            tokenRef.current = null;
        },
        getToken: () => tokenRef.current?.token?.raw,
        setToken
    };
};
//# sourceMappingURL=protocol.js.map